<template>
  <el-dialog
    :visible.sync="visible"
    append-to-body
    :destroy-on-close="true"	
    :show-close="true"
    :center="true"
    @close="handleClose"
    title="合同模版详情"
    width="700px"
  >
    <div>
      <el-form ref="form" :model="formData"  :rules="rules" label-width="140px">
       
        <el-form-item label="合同名称" prop="contract_name" >  
          <el-input  type="text" v-model="formData.contract_name" ></el-input> 
        </el-form-item>

        <el-form-item label="合同类型" prop="contract_type" >
          <el-select v-model="formData.contract_type" placeholder="请选择" @change="changeType">
            <el-option label="在线合同" :value="1"></el-option>
            <el-option label="本地合同" :value="2"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="合同" prop="contract_content" >
                <vue-editor v-model="formData.contract_content" v-if="formData.contract_type==1"/>

                <el-upload
                v-if="formData.contract_type==2"
                class="upload"
                :action="uploadFileUrl"
                :file-list="fileList"
                :limit="1"
                :on-error="handleUploadError"
                :on-exceed="handleExceed"
                :on-success="handleUploadSuccess"
            
            >
                <el-button size="small" type="primary">点击上传</el-button>
                <div class="el-upload__tip" slot="tip">若文件合同有变更，请删除废弃的合同文件！</div>
              </el-upload>
        </el-form-item>

     

    
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取 消</el-button>
      <el-button type="primary" @click="submit">确 定</el-button>
    </span>

  </el-dialog>
</template>

<script>
import { addContractTpl,editContractTpl} from "@/api/director/project/index.js";
// 基本用途-涵盖大多数情况
//import { VueEditor } from "vue2-editor";

// 高级使用-HookQuill的API定制功能
import { VueEditor, Quill } from "vue2-editor";
import urlConfig from '@/api/config'

export default {
  components: { VueEditor },

  props: {
    project_id: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      visible: false,
      uploadFileUrl:  urlConfig.prod.baseURL +"/web/file/Upload", // 上传的图片服务器地址
      fileList: [],
      contract_file:"",
      contract_fname:"",

      formData: {
        template_id:"",
        contract_name:"",
        contract_type:1,
        contract_content: "",
      },
       rules: {
        contract_name: [
              {required: true, message: '请输入合同名称', trigger: 'change'}
          ],
          contract_type: [
              {required: true, message: '请选择合同类型', trigger: 'change'}
          ],
          contract_content: [
              {required: true, message: '请填写合同内容或者上传合同', trigger: 'change'}
          ],
         
         
       }
    };
  },

 
  mounted() {
    console.log("asdasdasd")

},
  
  methods: {
    handleClose() {
      this.$refs["form"].resetFields();
      this.resetForm();
      this.visible = false;
    },

    init(data) {
      console.log(data)
      if(data){
        this.formData.template_id=data.template_id;
        this.formData.contract_name=data.contract_name;
        this.formData.contract_type=data.contract_type;
        this.formData.contract_content=data.contract_content;

        if(this.formData.contract_type==2){
          this.fileList=[

          {name: '合同文件', url: this.formData.contract_content}
          ];
        }

      }else{
        this.resetForm();
      }
      this.visible = true;
    },



    changeType(e){
      console.log(e);
      if(e==1){
        this.formData.contract_content="";
        this.contract_file="";
        this.contract_fname="";
      }else{
        this.formData.contract_content="";
      }

    },

    resetForm(){
      this.formData= {
        template_id:"",
        contract_name:"",
        contract_type:1,
        contract_content: "",
        
      }
      this.contract_file='';
      this.contract_fname='';
    },





     // 文件个数超出
     handleExceed() {
      this.$message.error(`只允许上传单个文件`);
    },
    // 上传失败
    handleUploadError(err) {
      this.$message.error("上传失败, 请重试");
    },
    // 上传成功回调
    handleUploadSuccess(res, file) {
      console.log(res);
      this.contract_file=res.file;
      this.contract_fname=res.filename;
      this.$message.success("上传成功");
      console.log(this.formData);
     
    },
    // 删除文件
    handleDelete(index) {
     // this.fileList.splice(index, 1);
      this.fileList=[];
      this.contract_file='';
      this.contract_fname='';
     
    },
    // 获取文件名称
    getFileName(name) {
      if (name.lastIndexOf("/") > -1) {
        return name.slice(name.lastIndexOf("/") + 1).toLowerCase();
      } else {
        return "";
      }
    },

    
    
    submit(){
      var that=this;
      that.formData.project_id=this.project_id;

      if(this.formData.contract_type==2){
        this.formData.contract_content=this.contract_file;
      }

      this.$refs["form"].validate((valid) => {
          if (valid) {
            if(that.formData.template_id){
              editContractTpl(that.formData).then((response) => {
                console.log(response);
                if(response.code==200){
                  this.$message({
                    message: "提交成功",
                    type: 'success'

                  });
                  that.$emit('refresh');
                  that.visible = false;
                
                }else{
                  this.$message({
                    message: response.msg?response.msg:"提交失败",
                  });
                }
              });
            }else{
              addContractTpl(that.formData).then((response) => {
                console.log(response);
                if(response.code==200){
                  this.$message({
                    message: "提交成功",
                    type: 'success'

                  });
                  that.$emit('refresh');
                  that.visible = false;
                
                }else{
                  this.$message({
                    message: response.msg?response.msg:"提交失败",
                  });
                }
              });
            }
            
          } 
        });

    },

    
  },

 
};
</script>

<style lang="scss" scoped>



::v-deep .myWindow {
    border-radius: 15px;



/*
.footer{
  display: flex;
  justify-content: center;
}*/


  }
</style>
